import React, { useEffect, useState } from 'react';

import { getSubAbas } from './subabas';
import BarraSubAbas from '../../../components/BarraSubAbas';
import ContainerConteudo from '../../../components/ContainerConteudo';
import Tabela from '../../../components/Tabela';
import { getAllRelatorios } from '../../../services/relatorios/relatoriosService';
import {
  formataNomeMeioSiglas,
  formatDate,
  formatDateSimp,
} from '../../../utils/functions';

const DadosRelatorios: React.FC = () => {
  const [data, setData] = useState<any[]>([]);

  const headers = [
    { text: '', width: 1, key: '' },
    { text: 'ID', width: 2, key: 'id' },
    { text: 'Data/Hora', width: 10, key: 'dataAcao' },
    { text: 'Usuário', width: 10, key: 'nomeCompleto' },
    { text: 'Titulo', width: 10, key: 'titulo' },
    { text: 'Template', width: 10, key: 'template' },
    { text: 'Última Visualização', width: 10, key: 'entidade' },
    //{ text: 'Link', width: 10, key: 'entidade' },
  ];

  // Função para buscar dados
  useEffect(() => {
    const fetchData = async () => {
      try {
        const logAcoesData = await getAllRelatorios();
        setData(logAcoesData);
      } catch (error) {
        console.error('Erro ao obter dados:', error);
      }
    };
    fetchData();
  }, []);

  // Dados da tabela
  const tableData = data.map((item) => ({
    ID: item.id,
    'Data Gerada': formatDateSimp(item.dtRelatorioGerado),
    Usuário: formataNomeMeioSiglas(item.usuarioRegistro?.nomeCompleto || ''),
    Titulo: item.dsTitulo,
    Template: item.dsTemplate,
    //  Visualizações: item.nVisualizacoes,
    'Última Visualização': formatDate(item.dtUltimaVisualizacao),
    // Observações: item.observacoes || '-',
    //Link: `/relatorios/${item.id}/detalhes`,
  }));

  // Dados do Offcanvas
  const offCanvasData = tableData;
  return (
    <>
      <BarraSubAbas subAbas={getSubAbas()} />

      <ContainerConteudo>
        <Tabela
          headers={headers}
          dataTable={tableData}
          dataOffCanvas={offCanvasData}
          rowClickable={false}
        />
      </ContainerConteudo>
    </>
  );
};
export default DadosRelatorios;
